import { Injectable } from "@angular/core";
import { UserConnector } from "./user.connector";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { AppServerUserConnector } from "../../app-server-connectors";
import { APIResponse, OrganisationDocument, UserDocument } from "server-model";

@Injectable()
export class UserDataService {
    private userConnector: UserConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.userConnector = new AppServerUserConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getUser(userId: string): Promise<APIResponse> {
        const response = await this.userConnector.getUser(userId);
        return response;
    }
    async createUser(userDocument: UserDocument): Promise<APIResponse> {
        const response = await this.userConnector.createUser(userDocument);
        return response;
    }
    async updateUser(userId: string, userDocument: UserDocument): Promise<APIResponse> {
        const response = await this.userConnector.updateUser(userId, userDocument);
        return response;
    }
    async deleteUser(userId: string): Promise<APIResponse> {
        const response = await this.userConnector.deleteUser(userId);
        return response;
    }
    async getUserOrganisations(userId: string): Promise<APIResponse> {
        const response = await this.userConnector.getUserOrganisations(userId);
        return response;
    }
    async getOrganisationUser(userId: string, organisationId: string): Promise<APIResponse> {
        const response = await this.userConnector.getOrganisationUser(userId, organisationId);
        return response;
    }
}